export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Files.json?hash=172489bff61c337677e7e8af57183b9e";